<widget-card>
    <loading-and-error
        [hasNoData]="true"
        [noDataTitle]="'WIDGET.MONOSITE_ONLY.MESSAGE' | translate"
        [noDataMessage]="'WIDGET.MONOSITE_ONLY.DETAIL' | translate"
        [noDataPictureUrl]="null"
    />
</widget-card>
